import { Link } from "react-router-dom";
import { CertifiedBadge } from "@/components/CertifiedBadge";
import { MapPin, Sparkles } from "lucide-react";

const WELLNESS_MIN_SCORE = 95;

export function PropertyCard({ p, idx = 0 }) {
  const photo = p.photos?.[0] || "https://images.unsplash.com/photo-1584132967334-10e028bd69f7?w=1200";
  const isWellnessReady = (p.freshness_score || 0) >= WELLNESS_MIN_SCORE && p.status === "certified";
  return (
    <Link
      to={`/property/${p.id}`}
      data-testid={`property-card-${p.id}`}
      className="group block bg-white rounded-2xl overflow-hidden border border-slate-200 hover:-translate-y-1 hover:shadow-xl transition-transform duration-200"
      style={{ animationDelay: `${idx * 60}ms` }}
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        <img
          src={photo} alt={p.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-3 left-3 flex flex-col gap-1.5 items-start">
          <CertifiedBadge tier={p.certification_tier || "standard"} compact />
          {isWellnessReady && (
            <span
              className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-emerald-600 text-white text-[10px] tracking-[0.16em] uppercase font-semibold shadow-md backdrop-blur-sm"
              data-testid={`wellness-ready-badge-${p.id}`}
              title="Freshness score ≥95 — suitable for allergy sufferers, families, and immunocompromised guests"
            >
              <Sparkles className="w-2.5 h-2.5" /> Wellness Ready
            </span>
          )}
        </div>
        <div className="absolute bottom-3 right-3 bg-white/90 backdrop-blur px-3 py-1.5 rounded-full flex items-center gap-1.5">
          <span className="w-2 h-2 rounded-full bg-emerald-500 pulse-ring inline-block" />
          <span className="text-sm font-semibold text-[#0A1128]" data-testid={`score-${p.id}`}>{p.freshness_score}</span>
          <span className="text-xs text-slate-500">/100</span>
        </div>
      </div>
      <div className="p-5">
        <h3 className="font-serif text-lg text-[#0A1128] leading-tight">{p.name}</h3>
        <div className="mt-2 flex items-center gap-1.5 text-sm text-slate-500">
          <MapPin className="w-3.5 h-3.5" /> {p.city}, {p.country}
        </div>
        <div className="mt-4 flex items-end justify-between">
          <div>
            {p.price_per_night && (
              <div className="font-serif text-xl text-[#0A1128]">
                ${p.price_per_night}
                <span className="text-xs text-slate-500 font-sans"> / night</span>
              </div>
            )}
          </div>
          <span className="text-xs tracking-[0.2em] uppercase text-emerald-700 font-semibold">View →</span>
        </div>
      </div>
    </Link>
  );
}
